export default "__VITE_ASSET__jBoZDgJk__"